import cn from 'classnames';
import styles from './divider.scss';

interface DividerProps {
  className?: string;
}

export const Divider = ({ className }: DividerProps) => (
  <div className={cn(styles.divider, className)} />
);
